import { c as _c } from "react/compiler-runtime";
interface TempoIconProps {
  className?: string;
}
export function TempoIcon(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <circle cx="100" cy="100" r="100" fill="white" />;
    t2 = <path d="M95.16,145h-24.60l22.80,-69.60h-29.16l6.36,-20.40h81.24l-6.36,20.40h-27.60l-22.68,69.60Z" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" className={className}>{t1}{t2}</svg>;
    $[2] = className;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}